import { CreativityType } from '../../types/banner';
import type { TemplateConfig } from '../../types/templates';
import { getCreativityOptions } from '../../clients/registry';
import { useClientId } from '../use-client-id';

export const useTemplateConfig = (creativityType?: CreativityType): TemplateConfig | undefined => {
  const clientId = useClientId();
  const options = getCreativityOptions(clientId);
  if (!creativityType) return undefined;
  return options.find(t => t.id === creativityType);
};
